import React, { Component } from 'react';
import {Button, Layout} from "antd";
import HeaderNav from "../header/header";
import "./css/disputeHome.css"
import {
    dispute_types,
    country_select_list,
    usfLogin
} from "../../requist";
import Swiper from "swiper";
import 'swiper/css/swiper.css';

const { Content } = Layout;

class DisputeHome extends Component{
    constructor(props){
        super(props);
        this.state={
            userType:'external'
        }
    }
    getQueryVariable(variable){
        let reg = new RegExp("(^|&)" + variable + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    }
    componentWillMount(){
        // let ticket = this.getQueryVariable('ticket')
        // if(ticket){
        //     getIdByticketLI(ticket).then(res=>{
        //         window.localStorage.setItem('menuList',JSON.stringify(SAPCustomer));
        //         if(res.result){
        //             window.localStorage.removeItem('userId');
        //             window.localStorage.removeItem('userToken');
        //             window.localStorage.setItem('userToken',res.userToken);
        //             window.localStorage.setItem('userId', res.data.requestorID);
        //             window.localStorage.removeItem('userInfo');
        //             window.localStorage.setItem('userInfo',JSON.stringify(res.data));
        //             this.props.history.push({
        //                 pathname: '/disputeHome'
        //             })
        //             window.location.reload()
        //         }else{
        //             window.localStorage.removeItem('userId');
        //             message.error(`${res.msg}`)
        //         }
        //     })
        // }
        let orignalSetItem = localStorage.setItem;
        localStorage.setItem = function(key,newValue){
            var setItemEvent = new Event("setItemEvent");
            setItemEvent.newValue = newValue;
            window.dispatchEvent(setItemEvent);
            orignalSetItem.apply(this,arguments);
        }
        // if(this.props.history.location.pathname==="/usfLogin"){
        //     let token = this.getQueryVariable('token')
        //     window.localStorage.removeItem('userToken');
        //     window.localStorage.setItem('userToken',token);
        //     window.localStorage.removeItem('menuList');
        //     toggleTenant().then(res=>{
        //         const {code}=res;
        //         if(code===0){
        //             checkToken(token).then(res=>{
        //                 const {data} = res;
        //                 let userInfo = {
        //                     requestorEmail: data.email,
        //                     requestorID: data.username,
        //                     requestorPhoneNo: data.callPhone,
        //                 }
        //                 window.localStorage.setItem('userId', data.username);
        //                 localStorage.setItem('userInfo',JSON.stringify(userInfo));
        //             })
        //             getMenuTree().then(res=>{
        //                 const {data} = res;
        //                 if(data && data.length){
        //                     localStorage.setItem('menuList',JSON.stringify(data[0].childMenuList));
        //                     window.localStorage.setItem('menuList',JSON.stringify(data[0].childMenuList));
        //                     // window.location.reload()
        //                 }
        //             })
        //         }
        //     })
        // }
        let we_p_dispute_types=[];
        let we_d_dispute_types=[];
        let em_p_dispute_types=[];
        let em_d_dispute_types=[];
        let userId = window.localStorage.getItem('userId')
        userId && dispute_types().then((res)=>{
            if(res.retCode==='200'){
                res.data.forEach((item)=>{
                    if(item.region==="WE" && item.businessUnit==="P"){
                        we_p_dispute_types.push(item)
                    }
                    if(item.region==="WE" && item.businessUnit==="D"){
                        we_d_dispute_types.push(item)
                    }
                    if(item.region==="EM" && item.businessUnit==="P"){
                        em_p_dispute_types.push(item)
                    }
                    if(item.region==="EM" && item.businessUnit==="D"){
                        em_d_dispute_types.push(item)
                    }
                })
                window.sessionStorage.setItem('we_p_dispute_types',JSON.stringify(we_p_dispute_types))
                window.sessionStorage.setItem('we_d_dispute_types',JSON.stringify(we_d_dispute_types))
                window.sessionStorage.setItem('em_p_dispute_types',JSON.stringify(em_p_dispute_types))
                window.sessionStorage.setItem('em_d_dispute_types',JSON.stringify(em_d_dispute_types))
            }
        })
        let we_country_Texts=[]
        userId && country_select_list('WE').then((res)=>{
            if(res.retCode==="200"){
                we_country_Texts.push(res.data[0].countryTexts)
                window.sessionStorage.setItem('we_country_Texts',JSON.stringify(we_country_Texts))
            }
        })
    }
    componentDidMount() {
        //Carousel
        this.swiperObj = new Swiper('.swiper-container', {
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 2300,
            },
            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },
            observer: true,
            observeParents: true,
        })
    }
    usfLogin=(e)=>{
        usfLogin().then(res=>{
            window.location.href=res
        })
    }
    gotoLPH=(e)=>{
        window.location.href="https://www.lenovopartnerhub.com"
    }
    render() {
        let userId = window.localStorage.getItem('userId')
        return <div>
            <HeaderNav parmas={''}/>
            <Layout className="site-layout-background" style={{ padding: '24px 0' }}>
                <Content className="dispute_home_content">
                    <div className="swiper-container">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <img src="assets/home-img.jpg" style={{width:'950px',display:"block",margin:"0 auto"}} />
                            </div>
                            <div className="swiper-slide">
                                <img src="assets/home-img2.jpg" style={{width:'950px',display:"block",margin:"0 auto"}} />
                            </div>
                            <div className="swiper-slide">
                                <img src="assets/home-img3.jpg" style={{width:'950px',display:"block",margin:"0 auto"}} />
                            </div>
                            <div className="swiper-slide">
                                <img src="assets/home-img.png" style={{width:'950px',display:"block",margin:"0 auto"}} />
                            </div>
                            <div className="swiper-slide">
                                <img src="assets/home-img4.jpg" style={{width:'950px',display:"block",margin:"0 auto"}} />
                            </div>
                        </div>
                    </div>
                    <div className="login_btn_box partner_btn">
                        {
                            !userId?<Button type="primary" onClick={()=>{
                                this.props.history.push({
                                    pathname: '/lhp'
                                })
                            }}>
                                New Partner?  Click here to Get Started
                            </Button>:''
                        }
                    </div>
                    <div className="login_btn_box">
                            { !userId ? <Button authType = 'ADFS' onClick={this.usfLogin} type="primary">
                                    Internal Users Login
                            </Button>:''}
                            {
                                !userId?
                                    <Button style={{width:'320px'}} onClick={this.gotoLPH} type="primary">
                                        Business Partners Should be login via LPH
                                    </Button>:''
                            }
                    </div>
                </Content>
            </Layout>
        </div>
    }
}

export default DisputeHome;